import { useSelector } from 'react-redux';

import { useNewbuildingMortgageCalculatorMicrofront } from 'shared/hooks/useNewbuildingMortgageCalculatorMicrofront';
import { getNewbuildingPromos } from 'shared/selectors/newObject';
import { getPromoInfos } from 'shared/selectors/newObject/getPromoInfos';

export function useNewbuildingPromos() {
  const { isAvailable: isMortgageCalculatorMicrofrontAvailable } = useNewbuildingMortgageCalculatorMicrofront();

  const nonMortgagePromos = useSelector(getNewbuildingPromos);
  const allPromos = useSelector(getPromoInfos);

  if (isMortgageCalculatorMicrofrontAvailable) {
    return allPromos;
  }

  return nonMortgagePromos;
}
